import * as IoC from 'typescript-ioc';
import { IApiClient } from '../../infrastructure/api-client';
import { IEventRequestParams } from '../shared.dto';
import { IEmailConfigurationDAO, IEmailsTemplateConfiguration, } from '../email-configuration.dao';

class EmailConfigurationDAO extends IEmailConfigurationDAO {
    static readonly emailsTemplateConfiguration: string = 'account/{accountId}/event/{eventId}/email-configuration';
    static readonly emailsDefaultTemplateConfiguration: string = 'account/{accountId}/event/{eventId}/email-configuration/defaults';
    static readonly sendEmailPreview: string = 'account/{accountId}/event/{eventId}/email-configuration/preview';

    constructor(@IoC.Inject private readonly apiClient: IApiClient) {
        super();
    }

    public async getTemplatesConfiguration(params: IEventRequestParams): Promise<IEmailsTemplateConfiguration> {
        const response = await this.apiClient.get<IEmailsTemplateConfiguration>(EmailConfigurationDAO.emailsTemplateConfiguration, params);
        return response.parsedResponse;
    }

    public async getDefaultTemplatesConfiguration(params: IEventRequestParams): Promise<IEmailsTemplateConfiguration> {
        const response = await this.apiClient.get<IEmailsTemplateConfiguration>(EmailConfigurationDAO.emailsDefaultTemplateConfiguration, params);
        return response.parsedResponse;
    }

    public async updateTemplatesConfiguration(params: IEventRequestParams & IEmailsTemplateConfiguration): Promise<IEmailsTemplateConfiguration> {
        const response = await this.apiClient.put<IEmailsTemplateConfiguration>(EmailConfigurationDAO.emailsTemplateConfiguration, params);
        return response.parsedResponse;
    }

    public async sendEmailPreview(type: string, params: IEventRequestParams): Promise<void> {
        const response = await this.apiClient.get<void>(
            EmailConfigurationDAO.sendEmailPreview,
            params,
            { uriParams: { type: type }},
        );
        return response.parsedResponse;
    }
}

export { EmailConfigurationDAO };
